module.exports = __webpack_public_path__ + "static/startup-1f256f5376b57b042bcd9fb4e4135be9.jpg";